import { useState } from "react";

import { Autocomplete, DialogContent, Stack, TextField, Typography } from "@mui/material";

import SimpleDialog from "../../../../SimpleDialog";
import { type BillingProfileInvoiceBucket } from "../../../BillingProfileForm.models";
import { getBucketTypeDisplayName } from "./utils";

const DeleteDefaultBucketDialog = ({
  bucketToDelete,
  bucketDefaultOptions,
  deleteBucket,
  onClose,
}: {
  bucketToDelete: BillingProfileInvoiceBucket;
  bucketDefaultOptions: BillingProfileInvoiceBucket[];
  deleteBucket: (bucket: BillingProfileInvoiceBucket, newDefaultBucket?: BillingProfileInvoiceBucket) => void;
  onClose: () => void;
}) => {
  const [newDefaultBucket, setNewDefaultBucket] = useState<BillingProfileInvoiceBucket | null>(
    bucketDefaultOptions.length === 1 ? bucketDefaultOptions[0] : null
  );

  return (
    <SimpleDialog
      open={true}
      title="Select new default bucket"
      onConfirm={() => {
        deleteBucket(bucketToDelete, newDefaultBucket ?? undefined);
        onClose();
      }}
      onCancel={onClose}
      dialogProps={{
        fullWidth: true,
        maxWidth: "xs",
      }}
      disableConfirm={!newDefaultBucket}
    >
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 2 }}>
          <Typography>
            You are deleting the current default bucket "{bucketToDelete.name}" for{" "}
            {getBucketTypeDisplayName(bucketToDelete.type)}. Please select a new default bucket from the list below
            before proceeding.
          </Typography>

          <Autocomplete
            options={bucketDefaultOptions}
            value={newDefaultBucket ?? undefined}
            disableClearable
            getOptionLabel={(option) => option.name}
            renderInput={(params) => <TextField {...params} label="Select new default bucket" size="small" />}
            onChange={(_event, newValue) => {
              setNewDefaultBucket(newValue);
            }}
          />
        </Stack>
      </DialogContent>
    </SimpleDialog>
  );
};

export default DeleteDefaultBucketDialog;
